/**
 * Module Bootstrap Code.
 *
 * @author Sadi Qevani
 */

(function (window, document, $) {
  "use strict";

  // $(function () {
  //   var feed = new Instafeed({
  //     get: "user",
  //     userId: "572976562",
  //     accessToken: "39a0502d0f2d413799c207d78877b591"
  //   });
  //
  //   feed.run();
  // });

}(window, document, jQuery));
